<template>
    <div class="pt-2 pl-2">
        <template v-if="!$vuetify.display.mobile">
            <v-row no-gutters>
                <v-col cols="7" class="pr-1">
                    <v-card class="default_card_wm elevation-0 pt-2">
                        <DocumentMenu
                            :MenuOptions="documentMenuOptions"
                            @back="back()"
                            @zoom-out="zoomManager.zoomOut()"
                            @reset-zoom="zoomManager.resetZoom()"
                            @rotate-left="
                                documentPdfRotation = rotate(
                                    'left',
                                    zoomManager,
                                    documentPdfRotation,
                                )
                            "
                            @rotate-right="
                                documentPdfRotation = rotate(
                                    'right',
                                    zoomManager,
                                    documentPdfRotation,
                                )
                            "
                            @zoom-in="zoomManager.zoomIn()"
                            @download="startDownloadFile()"
                            @delete="deleteDocumentDialog = true"
                        />
                        <v-row no-gutters>
                            <!--<v-col cols="6">
                                <v-btn-back
                                    @click.stop="back()"
                                    v-if="mode !== 'GeneralLedger' && goBackHistory"
                                    data-cy="document-back"
                                />
                                <v-btn-icon
                                    icon="$oss-zoom-out"
                                    :disabled="zoomManager.disableZoomOut()"
                                    class="btn mr-1"
                                    @click.stop="zoomManager.zoomOut()"
                                    v-if="showZoomActions"
                                />
                                <v-btn-icon
                                    icon="$oss-focus"
                                    :disabled="zoomManager.disableResetZoom()"
                                    class="btn mx-1"
                                    @click.stop="zoomManager.resetZoom()"
                                    v-if="showZoomActions"
                                />
                                <v-btn-icon
                                    icon="$oss-zoom-in"
                                    :disabled="zoomManager.disableZoomIn()"
                                    class="btn ml-1"
                                    @click.stop="zoomManager.zoomIn()"
                                    v-if="showZoomActions"
                                />
                            </v-col>
                            <v-col cols="6" class="d-flex justify-end">
                                <v-btn-icon
                                    icon="$oss-download"
                                    class="mx-1"
                                    @click="startDownloadFile"
                                />
                                <v-menu offset-y>
                                    <template v-slot:activator="{ props }">
                                        <v-btn-icon
                                            icon="$dots_vertical"
                                            v-bind="props"
                                            class="mx-1"
                                        />
                                    </template>
                                    <v-list nav rounded="xl">
                                        <!-- <v-list-item
                                            v-if="
                                                isEditable &&
                                                currentUser.profile.configuration.document.write
                                            "
                                            @click="editDialog = true"
                                        >
                                            <v-list-item-title>Editer</v-list-item-title>
                                            <template v-slot:append>
                                                <v-icon size="small">$oss-edit</v-icon>
                                            </template>
                                        </v-list-item>
                                        <v-divider />
                                        <v-list-item
                                            @click="deleteDocumentDialog = true"
                                            :disabled="disabledDelete"
                                            :color="disabledDelete ? '' : 'error'"
                                        >
                                            <v-list-item-title>Supprimer</v-list-item-title>
                                            <template v-slot:append>
                                                <v-icon size="small">$oss-trash</v-icon>
                                            </template>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-col>-->
                            <v-col cols="12" class="d-flex justify-center" v-if="isPDF">
                                <ossPdf :documentId="document.id" />
                            </v-col>
                            <v-col cols="12" style="max-height: 85vh; overflow-y: auto" v-else>
                                <div
                                    style="
                                        position: relative;
                                        width: 100%;
                                        height: 0;
                                        padding: 0;
                                        padding-bottom: 141.4516129032258%;
                                        margin-bottom: 50px;
                                    "
                                >
                                    <svg
                                        id="svg-document-chat"
                                        v-if="document"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="100%"
                                        :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                        style="
                                            position: absolute;
                                            width: 100%;
                                            left: 0;
                                            top: 0;
                                            background: #fff;
                                        "
                                    >
                                        <g>
                                            <image
                                                id="svg-image-document-chat"
                                                :xlink:href="document.signedUrl"
                                                x="0"
                                                y="0"
                                                :height="`${imageHeight}px`"
                                                :width="`${imageWidth}px`"
                                            />
                                            <template v-for="(variant, index) in svgVariants">
                                                <template
                                                    v-for="(coord, index2) in variant.coordinates"
                                                    :key="`coord-${document.id}-${index}-${index2}`"
                                                >
                                                    <polygon
                                                        :ref="`variants-${index}-${index2}`"
                                                        :points="getPoints(coord)"
                                                        :style="
                                                            variant.active
                                                                ? 'fill:rgba(250,250,250,0.5);stroke:#F9B12A;stroke-width:1'
                                                                : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                        "
                                                        @click.stop="
                                                            variant.active
                                                                ? ''
                                                                : showCorrespondingField({
                                                                      variant,
                                                                      currentIndex: index,
                                                                      copyIndex: index2,
                                                                  })
                                                        "
                                                        :class="variant.focus ? 'highlighted' : ''"
                                                    />
                                                </template>
                                            </template>
                                        </g>
                                    </svg>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-list v-if="associatedFields.show" :style="svgPosition">
                        <v-list-item
                            v-for="(field, key, index) in associatedFields.fields"
                            :key="`field-${document.id}-${key}-${index}`"
                            @click="onFieldAssociation(field, key)"
                            class="oss-list-item"
                        >
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col cols="5" class="my-0 pl-1">
                    <v-card
                        style="
                            border-top-right-radius: 0px !important;
                            border-bottom-right-radius: 0px !important;
                        "
                        class="default_card_wm elevation-0 rounded-l-0 fill-height"
                    >
                        <!-- <v-card style="position: fixed; margin-top: -3vh; max-height: 80vh; overflow-y: auto" class="default_card_wm"> -->
                        <v-card-title class="headline" style="width: 100%">
                            Demandes pour ce document
                        </v-card-title>
                        <v-card-text style="width: 100%">
                            <v-row no-gutters class="d-flex justify-center">
                                <v-col cols="12" class="oss-bordered">
                                    <Chat
                                        v-bind:id="document.chat ? document.chat.id : ''"
                                        v-bind:inShowMessage="open_chat"
                                        v-bind:chatTitle="'Document'"
                                        v-bind:cardMode="true"
                                        :showSmartChat="wishStatus !== 'DENIED'"
                                        @messageSent="onMessageSent($event)"
                                        @showMessageChanged="onShowMessageChanged($event)"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions
                            class="d-flex justify-center"
                            v-if="mode != 'GeneralLedger'"
                        >
                            <v-btn-icon
                                icon="$navigate_before"
                                :disabled="previousDisabled()"
                                color="secondary"
                                @click="previous()"
                            />
                            <v-btn-icon
                                icon="$navigate_next"
                                :disabled="nextDisabled()"
                                color="secondary"
                                @click="next()"
                            />
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <oss-dialog v-model="dialogChooseDownload" title="Télécharger le document" width="80vw">
                Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté).

                <template v-slot:actions>
                    <v-row no-gutters>
                        <v-col cols="6" class="pr-2">
                            <v-btn-primary
                                rounded
                                block
                                @click="
                                    dialogChooseDownload = false;
                                    downloadFile(true);
                                "
                                size="x-large"
                                >Original</v-btn-primary
                            >
                        </v-col>
                        <v-col cols="6" class="pl-2">
                            <v-btn-primary
                                rounded
                                block
                                @click="
                                    dialogChooseDownload = false;
                                    downloadFile(false);
                                "
                                size="x-large"
                                >Marqué</v-btn-primary
                            >
                        </v-col>
                    </v-row>
                </template>
            </oss-dialog>
            <oss-dialog
                v-model="deleteDocumentDialog"
                title="Supprimer le document"
                :error="true"
                @valid="deleteDocument"
                :validTitle="'Oui je suis sûr(e)'"
                :validLoading="deleteDocumentLoading"
                width="800px"
            >
                <h4 class="text-center">
                    &#xca;tes-vous sûr(e) de vouloir supprimer le document ?
                </h4>
            </oss-dialog>
        </template>
        <!-- Smartphone -->
        <template v-else>
            <!-- <v-container grid-list-md fluid class="fill-height pa-2"> -->
            <div class="fill-height pa-2">
                <v-row no-gutters>
                    <v-col cols="12" sm="7" style="display: flex">
                        <v-switch
                            v-model="showDocument"
                            hide-details
                            label="Afficher le document"
                            class="my-0 py-0"
                        />
                    </v-col>
                </v-row>
                <v-window v-model="step" class="fill-height">
                    <v-window-item :value="0">
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-form ref="form" v-model="valid">
                                    <v-divider />
                                    <div class="title font-weight-bold">
                                        {{
                                            thirdPartyType() +
                                            (document.thirdPartyCompany
                                                ? document.thirdPartyCompany.name
                                                : "")
                                        }}
                                    </div>
                                    <v-divider />
                                    <div style="margin-left: -2vw; margin-right: -2vw">
                                        <Chat
                                            v-bind:id="document.chat ? document.chat.id : ''"
                                            v-bind:inShowMessage="open_chat"
                                            v-bind:chatTitle="'Document'"
                                            v-bind:cardMode="true"
                                            @messageSent="onMessageSent($event)"
                                            @showMessageChanged="onShowMessageChanged($event)"
                                        />
                                    </div>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </v-window-item>
                    <v-window-item fill-height :value="1">
                        <v-layout wrap>
                            <!-- <v-flex xs12 sm7 @click="showDocument = false" v-if="showDocument"> -->
                            <v-flex xs12 sm7>
                                <div style="text-align: center; width: 100%">
                                    <div
                                        style="
                                            position: relative;
                                            width: 100%;
                                            height: 100%;
                                            padding: 0;
                                            padding-bottom: 141.4516129032258%;
                                        "
                                    >
                                        <span>{{ document.name }}</span>
                                        <svg
                                            id="svg-document-validation-mobile"
                                            v-if="document"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                            width="100%"
                                            :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                            style="position: absolute; width: 100%; left: 0; top: 0"
                                            class="elevation-2"
                                        >
                                            <image
                                                id="svg-image-document-validation-mobile"
                                                :xlink:href="document.signedUrl"
                                                x="0"
                                                y="0"
                                                :height="`${imageHeight}px`"
                                                :width="`${imageWidth}px`"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-window-item>
                </v-window>
            </div>
        </template>
    </div>
</template>

<script lang="ts">
import Chat from "../chat/Chat.vue";
import { DocumentBase } from "./DocumentBase";
import { DocumentMenu } from "./DocumentMenu.vue";
import ossPdf from "./DocumentPDF.vue";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

import {
    MenuDisplayDotMenuOptions,
    MenuDisplayDownloadOptions,
    MenuDisplayOptions,
    MenuDisplayZoomOptions,
    MenuDisplayRotationOptions,
} from "@/types/documentMenu.types";

import documentMenuDisplayOptionsDefaultScheme from "@/assets/json/documentMenuMenuDisplayOptionDefaultScheme.json";

@Component({
    components: {
        Chat,
        ossPdf,
    },
})
export class DocumentChat extends DocumentBase {
    step: number = 0;

    get showDocument() {
        return !!this.step;
    }

    set showDocument(value) {
        this.step = value ? 1 : 0;
    }

    valid = false;

    validated = false;

    loading = false;

    updating = false;

    dialogSelectCompany = false;

    get documentMenuZoomOptions(): MenuDisplayZoomOptions {
        const zoomOptions: MenuDisplayZoomOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.zoomButtons,
        };

        zoomOptions.isDisplay = this.showZoomActions;
        zoomOptions.isResetZoomDisabled = this.zoomManager.disableResetZoom();
        zoomOptions.isZoomInDisabled = this.zoomManager.disableZoomIn();
        zoomOptions.isZoomOutDisabled = this.zoomManager.disableZoomOut();

        return zoomOptions;
    }

    get documentMenuDownloadOptions(): MenuDisplayDownloadOptions {
        const downloadOptions: MenuDisplayDownloadOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.downloadButton,
        };

        downloadOptions.isDisplay = true;

        return downloadOptions;
    }

    get documentMenuDotMenuOptions(): MenuDisplayDotMenuOptions {
        const dotMenuOptions: MenuDisplayDotMenuOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.dotMenu,
        };

        dotMenuOptions.isDisplay = true;

        dotMenuOptions.delete.isDisplay = true;
        dotMenuOptions.delete.title = "Supprimer";
        dotMenuOptions.delete.disabled = this.disabledDelete;

        return dotMenuOptions;
    }
    get documentMenuOptionsRotateDocumentButton(): MenuDisplayRotationOptions {
        let rotationButton: MenuDisplayRotationOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.RotateDocument,
        };
        rotationButton.isDisplay = this.showRotateActions;

        return rotationButton;
    }

    get documentMenuOptions(): MenuDisplayOptions {
        const documentMenuOption: MenuDisplayOptions = {
            ...documentMenuDisplayOptionsDefaultScheme,
        };

        documentMenuOption.zoomButtons = this.documentMenuZoomOptions;
        documentMenuOption.RotateDocument = this.documentMenuOptionsRotateDocumentButton;
        documentMenuOption.downloadButton = this.documentMenuDownloadOptions;
        documentMenuOption.dotMenu = this.documentMenuDotMenuOptions;

        return documentMenuOption;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    getAmountClass(price) {
        let amountClass = "d-flex justify-center ";
        amountClass += price.total ? "font-weight-bold" : "font-weight-regular";
        return amountClass;
    }

    buildMetadata(document: any, key: string, valueType = "number") {
        return document[`${key}`];
    }

    @Watch("documentId")
    async onDocumentChanged(prev, next) {
        await this.onDocumentChangedCommon(prev, next);
        if (prev !== next) {
            this.dueDate = this.inDocument.dueDate || this.inDocument.date;
        }
        this.finishMounted();
    }

    beforeMount() {
        this.svgSuffix = "document-chat";
        this.onDocumentChanged(this.inDocument.id, undefined);
    }

    updateForm(document: any) {
        this.document = document;
        console.log("heheheh", document.signedUrl);
        this.computeSVGVariants(document);
    }

    formatOrderBy() {
        const fieldName = this.pagination.sortBy[0] || "type";
        let direction = "";
        if (fieldName !== "updatedAt") {
            direction = this.pagination.descending[0] ? "_DESC" : "_ASC";
        } else {
            direction = this.pagination.descending[0] ? "_ASC" : "_DESC";
        }
        return fieldName + direction;
    }

    onAllAsksResponded() {
        this.$emit("task-ended", {
            documentId: this.documentId,
        });
    }
}

export default toNative(DocumentChat);
</script>
<style lang="scss" scoped>
.v-input--has-state.text-red .v-label {
    animation: none !important;
    transition: none !important;
}

.theme--light.v-label {
    color: black !important;
}

.svg-pan-zoom_viewport {
    transition: transform 0.4s ease-out !important;
}

.inline-text-field {
    max-width: 140px;
    margin-right: 10px;
    display: inline-block;
}

.text-field-icon--associated {
    display: flex;
}

i.inline-icon {
    display: flex;
    height: 55px;
    width: 30px;
}

polygon.highlighted {
    fill: rgba(249, 177, 42, 0.5) !important;
}

.v-input--is-disabled {
    pointer-events: all !important;
}
</style>
